import { toast } from '@tempo-io/sui-sonner';
import { useTranslation } from 'react-i18next';
import { DeleteDialog } from '@/components/common/delete-dialog';
import type { Item } from '@/lib/api/types/items';
import { useItemPanelNavigation } from '@/lib/hooks/item-panel/useItemPanelParams';
import { useDeleteItemMutation } from '@/lib/mutations/common/item/useDeleteItemMutation';

export const DeleteItemDialog = ({
  item,
  onOpenChange,
}: {
  item: Item;
  onOpenChange: (open: boolean) => void;
}) => {
  const { t } = useTranslation();
  const { closeItemPanel } = useItemPanelNavigation();
  const deleteItemMutation = useDeleteItemMutation();

  return (
    <DeleteDialog
      open
      onOpenChange={onOpenChange}
      isPending={deleteItemMutation.isPending}
      title={t(($) => $.adaptivePlanner.itemPanel.delete.title)}
      description={
        <p>
          {t(($) => $.adaptivePlanner.itemPanel.delete.description, {
            itemName: item.name,
          })}
        </p>
      }
      cancelLabel={t(($) => $.adaptivePlanner.itemPanel.delete.cancel)}
      confirmLabel={t(($) => $.adaptivePlanner.itemPanel.delete.confirm)}
      onConfirm={() => {
        deleteItemMutation.mutate(
          { itemId: item.id },
          {
            onSuccess: () => {
              toast.success(t(($) => $.adaptivePlanner.itemPanel.delete.success));
              onOpenChange(false);
              closeItemPanel();
            },
            onError: () => {
              toast.error(t(($) => $.adaptivePlanner.itemPanel.delete.error));
            },
          },
        );
      }}
    />
  );
};
